import React, { useState, useEffest } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import querystring from 'querystring';
import classnames from 'classnames';
import {deselectItem, selectItem, updateItem as dispatchUpdateItem} from '../../../actions/contents/post';
import {jsonResponseHandler} from '../../../utils/FetchHelper'
import EntryItemCheckbox from "../../common/EntryItemCheckbox";
import {Link} from 'react-router-dom'
import * as StatusTypes from "../../../constants/contents/EntryStatusTypes";
import PostListItemButton from "./PostListItemButton";
import * as ContentsVisibility from "../../../constants/ContentsVisibility"
import {addPrefix} from "../../../utils/UriUtil";


function PostTitle({post}) {
  return (
    <strong className="tit_post tit_ellip">
      <a href={post.permalink} title={post.title} className="link_cont" target="_blank" onClick={e => post.deleting && e.preventDefault()}>
        {post.isRestrict && <span className="info_status">[{post.restrictLabel}]</span>}
        {post.isScheduled && <span className="info_status">[예약]</span>}
        {post.title}
      </a>
      {post.hasFile && <span className="ico_blog ico_file"/>}
    </strong>
  );
}

function PostCategory({ post }) {
  const categoryId = parseInt(post.categoryId) === -3 ? '' : post.categoryId;

  return (
    <Link to={`/posts?category=${categoryId}`}>
      <span className="txt_cate txt_ellip">{post.category}</span>
    </Link>
  )
}

function PostCommentCount({ post }) {
  if (post.countOfComments > 0) {
    let countText = (9999 < post.countOfComments) ? "9999+" : post.countOfComments; // 9999 이상은 + 처리
    return <span className="txt_info">댓글 {countText}</span>
  }

  return null;
}

function PostStatus({post}) {
  const isPrivateContents = ContentsVisibility.isPrivate(post.visibility, post.categoryVisibility);

  if (isPrivateContents) {
    return <span className="ico_blog ico_private">비공개</span>
  }

  if (post.visibility === StatusTypes.PROTECTED) {
    return <span className="ico_blog ico_secret">보호</span>
  }

  return null
}

function PostPassword({post}) {
  if (post.visibility === StatusTypes.PROTECTED) {
    return <span className="txt_info txt_ellip txt_password">비밀번호 {post.postPassword}</span>
  }

  return null
}

export default function PostListItem({item, listItemType}) {

  const dispatch = useDispatch()

  function handleSelectItem(id) {
    dispatch(selectItem(id))
  }
  function handleDeselectItem(id) {
    dispatch(deselectItem(id))
  }
  function handleUpdateItem(item) {
    dispatch(dispatchUpdateItem(item))
  }

  function handleSelect(e) {
    if (item.selected) {
      handleDeselectItem(item.id)
    } else {
      handleSelectItem(item.id)
    }
  }

  function updateItem(item, oldVisibility, newVisibility) {
    item.processing = true;

    // /manage/[post/notice/page/]/id/visibility.json
    fetch(addPrefix(`/manage/${listItemType}/${item.id}/visibility.json`), {
      method: "put",
      credentials: "include",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: querystring.stringify(
        Object.assign({}, {visibility: newVisibility})
      )
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        item.processing = false;
        item.visibility = newVisibility;
        handleUpdateItem(item);
      })
      .catch(e => {
        item.processing = false;
        item.visibility = oldVisibility;
        handleUpdateItem(item);
        console.log(e)
      })
  }

  function handleVisible(item) {
    const oldVisibility = item.visibility;
    updateItem(item, oldVisibility, StatusTypes.PUBLIC);
  }

  function handleHidden(item) {
    const oldVisibility = item.visibility;
    updateItem(item, oldVisibility, StatusTypes.PRIVATE);
  }

  function handleFollowed(item) {
    const oldVisibility = item.visibility;
    updateItem(item, oldVisibility, StatusTypes.FOLLOWED);
  }

  function handleProtect(item) {
    const oldVisibility = item.visibility;
    updateItem(item, oldVisibility, StatusTypes.PROTECTED);
  }

  return (
    <li className={classnames({item_dimmed: item.deleting})}>
      <EntryItemCheckbox item={item} handleSelect={handleSelect}/>

      <div className="post_cont">
        <PostTitle post={item} />
        <PostCategory post={item} />
        <span className="txt_info txt_ellip">{item.author}</span>
        <span className="txt_info">{item.published}</span>
        <PostCommentCount post={item} />
        <PostPassword post={item} />
      </div>

      <div className="post_btn">
        <PostStatus post={item} />
        <div className="info_btn">
          <PostListItemButton
            item={item}
            handleHidden={handleHidden}
            handleVisible={handleVisible}
            handleProtect={handleProtect}
            handleFollowed={handleFollowed}
          />
        </div>
      </div>
    </li>
  )
}
